// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-user-info {
  color: #5b5e5d;
  font-family: Roboto;
  font-size: 14px;
}
.view-product-btn-chatbox-modal {
  background-color: #f0f0f0;
  font-family: Roboto;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
  height: 48px;
}

.chat-component-drawer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.chat-component-drawer .component-header-text {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  font-family: "Roboto";
}

.chat-component-drawer .component-header-sub-text {
  margin: 0;
  font-size: 16px;
  font-weight: 400;
  font-family: "Roboto";
  color: #6e6e6e;
}
.view-product-btn-chatbox-modal:hover {
  background-color: #f0f0f0 !important;
  font-family: Roboto;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
  height: 48px;
}
.view-product-btn-chatbox-Text {
  /* color: #0000 !important; */
  font-family: Roboto;
  font-size: 16px;
  font-weight: 400;
}

.product-chat-back-btn {
  background-color: #f0f0f0 !important;
  font-family: Roboto;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  height: 39px;
  width: 80px;
}
.product-chat-back-btn:hover {
  background-color: #f0f0f0 !important;
  font-family: Roboto !important;
  border: none !important;
  padding: 8px 16px !important;
  border-radius: 4px !important;
  cursor: pointer !important;
  height: 39px !important;
  width: 80px !important;
}

.products-chat-back-btn-txt {
  font-size: 16px;
  font-weight: 400;
  color: #000000;
  font-family: "Roboto";
}
@media (max-width: 1024px) {
  .chat-section-div {
    padding: 30px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/modal/chat-box-communication/ChatBoxModal.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,WAAW;AACb;AACA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".chat-user-info {\n  color: #5b5e5d;\n  font-family: Roboto;\n  font-size: 14px;\n}\n.view-product-btn-chatbox-modal {\n  background-color: #f0f0f0;\n  font-family: Roboto;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  width: 100%;\n  height: 48px;\n}\n\n.chat-component-drawer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.chat-component-drawer .component-header-text {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 500;\n  font-family: \"Roboto\";\n}\n\n.chat-component-drawer .component-header-sub-text {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 400;\n  font-family: \"Roboto\";\n  color: #6e6e6e;\n}\n.view-product-btn-chatbox-modal:hover {\n  background-color: #f0f0f0 !important;\n  font-family: Roboto;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  width: 100%;\n  height: 48px;\n}\n.view-product-btn-chatbox-Text {\n  /* color: #0000 !important; */\n  font-family: Roboto;\n  font-size: 16px;\n  font-weight: 400;\n}\n\n.product-chat-back-btn {\n  background-color: #f0f0f0 !important;\n  font-family: Roboto;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  height: 39px;\n  width: 80px;\n}\n.product-chat-back-btn:hover {\n  background-color: #f0f0f0 !important;\n  font-family: Roboto !important;\n  border: none !important;\n  padding: 8px 16px !important;\n  border-radius: 4px !important;\n  cursor: pointer !important;\n  height: 39px !important;\n  width: 80px !important;\n}\n\n.products-chat-back-btn-txt {\n  font-size: 16px;\n  font-weight: 400;\n  color: #000000;\n  font-family: \"Roboto\";\n}\n@media (max-width: 1024px) {\n  .chat-section-div {\n    padding: 30px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
